import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["replyForm"]

  toggleReply(event) {
    const commentId = event.currentTarget.dataset.commentId
    const form = document.getElementById(`reply-form-${commentId}`)
    
    if (form.classList.contains('hidden')) {
      // Hide all other reply forms first
      document.querySelectorAll('[id^="reply-form-"]').forEach(f => {
        if (f !== form) f.classList.add('hidden')
      })
      
      form.classList.remove('hidden')
      const textarea = form.querySelector('textarea')
      textarea.focus()
    } else {
      form.classList.add('hidden')
    }
  }

  cancelReply(event) {
    const commentId = event.currentTarget.dataset.commentId
    const form = document.getElementById(`reply-form-${commentId}`)
    form.classList.add('hidden')
    
    // Clear the textarea
    const textarea = form.querySelector('textarea')
    textarea.value = ''
  }
  
  toggleReplies(event) {
    const commentId = event.currentTarget.dataset.commentId
    const repliesContainer = document.getElementById(`replies-${commentId}`)
    const button = event.currentTarget
    const icon = button.querySelector('i')
    
    if (repliesContainer.classList.contains('hidden')) {
      // Show replies with animation
      repliesContainer.classList.remove('hidden')
      repliesContainer.style.opacity = '0'
      repliesContainer.style.transform = 'translateY(-10px)'
      
      requestAnimationFrame(() => {
        repliesContainer.style.transition = 'all 0.3s ease-out'
        repliesContainer.style.opacity = '1'
        repliesContainer.style.transform = 'translateY(0)'
      })
      
      // Update button text and icon
      icon.classList.remove('fa-comments')
      icon.classList.add('fa-chevron-up')
      button.querySelector('.replies-count').textContent = 'Hide replies'
      
    } else {
      // Hide replies with animation
      repliesContainer.style.transition = 'all 0.2s ease-in'
      repliesContainer.style.opacity = '0'
      repliesContainer.style.transform = 'translateY(-10px)'
      
      setTimeout(() => {
        repliesContainer.classList.add('hidden')
      }, 200)
      
      // Update button text and icon
      icon.classList.remove('fa-chevron-up')
      icon.classList.add('fa-comments')
      const replyCount = repliesContainer.querySelectorAll('[data-controller="comments"]').length
      button.querySelector('.replies-count').textContent = replyCount === 1 ? '1 reply' : `${replyCount} replies`
    }
  }
}